// Code reused from the Header & Footer component
import { useCallback, useRef } from 'react';

const getNavElement = () => {
  if (typeof document === 'undefined') return null;
  return document.querySelector('#header-nav-container');
};

const isScrollbarVisible = () => {
  return window.innerWidth > document.documentElement.clientWidth;
};

const getScrollbarSize = () => {
  return Math.abs(window.innerWidth - document.documentElement.clientWidth);
};

export const useScrollLock = () => {
  const headerNav = getNavElement();
  const isLocked = useRef(false);
  const savedScrollY = useRef(0);

  const lockScroll = useCallback(() => {
    if (!isLocked.current && typeof document !== 'undefined') {
      if (isScrollbarVisible()) {
        document.body.style.paddingRight = `${getScrollbarSize()}px`;
        if (headerNav) {
          if ('positionBottom' in headerNav.dataset) {
            headerNav.style.paddingRight = `${getScrollbarSize()}px`;
          }
        }
      }
      document.body.style.overflow = 'hidden';

      savedScrollY.current = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${savedScrollY.current}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';

      isLocked.current = true;
    }
  }, []);

  const unlockScroll = useCallback(() => {
    if (isLocked.current && typeof document !== 'undefined') {
      document.body.style.removeProperty('padding-right');
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('position');
      document.body.style.removeProperty('top');
      document.body.style.removeProperty('left');
      document.body.style.removeProperty('right');

      isLocked.current = false;

      window.scrollTo({ top: savedScrollY.current, left: 0, behavior: 'instant' });

      if (headerNav) {
        headerNav.style.removeProperty('padding-right');
      }
    }
  }, []);

  return { lockScroll, unlockScroll };
};
